import { render, staticRenderFns } from "./zbsjk-select.vue?vue&type=template&id=dfc5fdb4&"
import script from "./zbsjk-select.vue?vue&type=script&lang=ts&"
export * from "./zbsjk-select.vue?vue&type=script&lang=ts&"
import style0 from "./zbsjk-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports